// ---
// Image Text Video
// ---

attachEvent('.image-text__video-replay', 'click', (ev) => {
  const parentElem = ev.target.closest('.image-text__video');
  const videoElem = parentElem.querySelector('video');

  videoElem.pause();
  videoElem.currentTime = '0';
  videoElem.play();

  ev.preventDefault();
});

// ---
// Video
// ---
const videosElem = document.querySelectorAll('video.switchVideoSource');

videosElem.forEach((video) => {
  const mp4Src = video.getAttribute('data-mp');
  const movSrc = video.getAttribute('data-mov');
  const webmSrc = video.getAttribute('data-webm');
  const sourceMp4 = document.createElement('source');
  const sourceMov = document.createElement('source');
  const sourceWebm = document.createElement('source');

  if (webmSrc) {
    sourceWebm.setAttribute('src', webmSrc);
    video.appendChild(sourceWebm);
  }

  if (movSrc) {
    sourceMov.setAttribute('src', movSrc);
    video.appendChild(sourceMov);
  }

  if (mp4Src) {
    sourceMp4.setAttribute('src', mp4Src);
    video.appendChild(sourceMp4);
  }

});

const webmFallbackDetection = () => {
  let fallBack = false;
  if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
    fallBack = true;
  }
  return fallBack;
};

if (webmFallbackDetection()) {
  document.body.classList.add('ios');
  videosElem.forEach((video) => {
    const sourceElem = video.querySelector('source');
    sourceElem.remove();
    video.classList.add('is-switched');
  });
}

if (!webmFallbackDetection()) {
  const vignettes = document.querySelectorAll('.image-text__video-vignette');
  vignettes.forEach((el) => {
    el.remove();
  });
}

// Play video animation on scroll
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const playPromise = entry.target.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              entry.target.play();
            })
            .catch(() => {});
        }
      }
    });
  },
  { threshold: 0.9 },
);

// Load videos on first scroll
const videos = document.querySelectorAll('.playMeOnScroll');
const loadVideosOnScroll = () => {
  const videoLazyLoaded = document.body.classList.contains('videos-loaded');
  if (!videoLazyLoaded) {
    videos.forEach((video) => {
      observer.observe(video);
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            video.pause();
          })
          .catch(() => {});
      }
    });
    document.body.classList.add('videos-loaded');
  }
};

loadVideosOnScroll();

window.addEventListener(
  'scroll',
  () => {
    loadVideosOnScroll();
  },
  false,
);

// Load Info on video

const videoInfos = document.querySelectorAll('.video-info');
videoInfos.forEach((videoInfo) => {
  const parent = videoInfo.closest('.image-text__video-inner');
  const video = parent.querySelector('video');
  const animationDelay = videoInfo.getAttribute('data-delay') / 1000;

  video.addEventListener('timeupdate', () => {
    videoInfo.classList.toggle('animate', video.currentTime >= animationDelay);
  });
});
